import { CloudUploadOutlined }   from '@ant-design/icons';
import { Modal }                 from '@widesk-ui/components/modal/Modal';
import ProjectVersionPublishForm from '@forms/map/ProjectVersionPublishForm';
import ModalTitle                from '@/components/ModalTitle';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';

const openPublishModal = () => Modal.open({
	// Même icône que le bouton d'où l'on vient — voir `ModalTitle`.
	title: <ModalTitle icon={<CloudUploadOutlined />}>Publier le projet</ModalTitle>,
	okText: 'Publier',
	// Plus étroit que les 750 par défaut : ce formulaire est une question courte, pas un écran.
	width: 520,
	children: <ProjectVersionPublishForm project={currentProjectEditorStore.get.project} />,
});

export default openPublishModal;
